<template>
    <div id="profitAndLossReport">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Profit And Loss Report</div>
                    <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportProfitLossSummary()">
                        <i class="fp-export"></i> Export
                    </a>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content profit-loss-report">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <div id="dataTableFilterConfig" class="border-top-table-fl mb-3">
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label">Type:</label>
                                    <v-select v-model="selectedFilter" name="selectedFilter" placeholder="Select Filter Type."
                                        label="text"
                                        :options="filterOptionsArr" id="selectedFilter" @input="filterTypeChange($event)">
                                    </v-select>       
                                </div>
                                <div class="col form-group" id="selectedYearSection">
                                    <label class="control-label">Year:</label>
                                    <v-select v-model="selectedYear" name="selectedYear" placeholder="Select Year."
                                            label="text"
                                            :options="taxSummaryYearArr" id="selectedYear">
                                    </v-select>       
                                </div>    
                                <div class="col form-group date-picker-filter hide" id="filterDateRange">
                                    <label class="control-label">Date Range:</label>
                                    <v-md-date-range-picker onkeydown="return false" autocomplete="off" @change="handleChange($event)" show-year-select></v-md-date-range-picker>
                                </div>
                            </div>
                            <div class="btn-groups text-right">
                                <button type="submit" value="Search" class="btn btn-primary" v-on:click="onColumnFilter('load')">
                                    <i class="fp-search"> </i>&nbsp;&nbsp; Search
                                </button>
                                <button type="submit" class="btn btn-tertiary" v-on:click="onColumnFilter('cancel')">
                                    <i class="fp-refresh"> </i>&nbsp;&nbsp; Reset 
                                </button>
                            </div>        
                        </div>
                        <section class="bg-white">
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>&nbsp;&nbsp;</th>
                                            <template v-for="(headerData , ind) in headerArr">
                                                <th :key="'header'+ind" class="text-right">
                                                    {{ headerData }}
                                                </th>    
                                            </template>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="profitLossSummary.length > 0">
                                            <template v-for="(profitLoss , key) in profitLossSummary">
                                                <tr :key="'incomeTitle'+key">
                                                    <td colspan="6" class="font-bold">
                                                        Income
                                                    </td>    
                                                </tr>
                                                <template v-if="profitLoss.income.account != undefined && profitLoss.income.account.length > 0">
                                                    <template v-for="(incomeAcc , key) in profitLoss.income.account">
                                                        <tr :key="'incAccData'+key">
                                                            <td> {{incomeAcc.gl_account_desc}}</td>
                                                            <template v-for="(incomeAmt , ind) in incomeAcc.amount">
                                                                <td :key="'incomeAccVal'+ind" class="text-right">
                                                                    {{ incomeAmt }}
                                                                </td>    
                                                            </template>
                                                        </tr>
                                                    </template>    
                                                </template>
                                                <tr :key="'incSumData'+key">
                                                    <td class="font-bold"> Total</td>
                                                    <template v-for="(incomeData , ind) in profitLoss.income.total">
                                                        <td :key="'income'+ind" class="font-bold text-right">
                                                            {{ incomeData }}
                                                        </td>    
                                                    </template>
                                                </tr>
                                                <tr :key="'expenseTitle'+key">
                                                    <td colspan="6" class="font-bold">
                                                        Expenses
                                                    </td>    
                                                </tr>
                                                <template v-if="profitLoss.expense.account != undefined && profitLoss.expense.account.length > 0">
                                                    <template v-for="(expenseAcc , key) in profitLoss.expense.account">
                                                        <tr :key="'expAccData'+key">
                                                            <td> {{expenseAcc.gl_account_desc}}</td>
                                                            <template v-for="(expenseAmt , ind) in expenseAcc.amount">
                                                                <td :key="'expAccVal'+ind" class="text-right">
                                                                    {{ expenseAmt }}
                                                                </td>    
                                                            </template>
                                                        </tr>
                                                    </template>    
                                                </template>
                                                <tr :key="'expSumData'+key">
                                                    <td class="font-bold"> Total</td>
                                                    <template v-for="(expenseData , ind) in profitLoss.expense.total">
                                                        <td :key="'expense'+ind" class="font-bold text-right">
                                                            {{ expenseData }}
                                                        </td>    
                                                    </template>
                                                </tr>
                                                <tr :key="'netTitle'+key">
                                                    <td class="font-bold">
                                                        Net Profit
                                                    </td>
                                                    <template v-for="(netData , ind) in profitLoss.net">
                                                        <td :key="'net'+ind" class="font-bold text-right">
                                                            {{ netData }}
                                                        </td>    
                                                    </template>    
                                                </tr>     
                                            </template>
                                        </template>    
                                    </tbody>    
                                </table>
                            </div>
                        </section>         
                    </div>        
                </div>    
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>    
    </div>    
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../../mixins/commonMixins';
import {contractMixins} from '../../../mixins/contractMixins';
import VMdDateRangePicker from "v-md-date-range-picker";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from 'moment';
Vue.use(VMdDateRangePicker);
export default {
    name: "ProfitAndLossReport",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Profit And Loss Report | " +process.env.COPYRIGHT_NAME
    },
    
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions:[],
        loading:false,
        cantAccessPage:"",
        profitLossSummary: [],
        dateFilter:{
            filterValue: null,
            filterDateValue: null
        },
        action:"list",
        filterOptionsArr:[
            {text:"Monthly",value:"month"},
            {text:"Quarterly",value:"quarter"},
            {text:"Custom",value:"custom"},
        ],
        selectedYear:"",
        selectedFilter:{text:"Quarterly",value:"quarter"},
        headerArr:[],
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'profit_and_loss_report') {
                    self.cantAccessPage = true;
                }
            });            
        }
    },
    created: function() {
    },
    mounted: function () {

        this.getPermissions();
        var self = this;
        setTimeout(function(){
            $("#filterDateRange .text-field").val("");   
        },300);
        var currentYear = self.getCurrentYear();
        self.selectedYear = { text : currentYear, value: currentYear}
        self.loadProfitAndLossReport();
    },
    methods:{
        handleChange (values) {
            this.values = values;
            var selectedDateArr = [];

            for( var i=0; i<values.length; i++ ) {
                selectedDateArr[i] = values[i].format('MM/DD/YYYY');
        
            }
            this.dateFilter.filterDateValue = selectedDateArr;
        },
        filterTypeChange(evt) {
            var self = this;
            $("#filterDateRange .text-field").removeClass('border-red');
            $("#selectedYear .dropdown-toggle").removeClass('border-red');
            $("#selectedFilter .dropdown-toggle").removeClass('border-red');
            if (self.selectedFilter != null) {
                if (self.selectedFilter.value == "custom") {
                    $('#filterDateRange').removeClass("hide");
                    $("#filterDateRange .text-field").val("");
                    self.dateFilter.filterDateValue = [];
                    if (!$('#selectedYearSection').hasClass("hide")) {
                        $('#selectedYearSection').addClass("hide");
                        self.selectedYear = "";    
                    }
                }else {
                    if (!$('#filterDateRange').hasClass("hide")) {
                        $('#filterDateRange').addClass("hide");
                        $("#filterDateRange .text-field").val("");
                        self.dateFilter.filterDateValue = [];
                    }
                    $('#selectedYearSection').removeClass("hide");
                    var currentYear = self.getCurrentYear();
                    self.selectedYear = { text : currentYear, value: currentYear}
                }
            }else{
                if (!$('#filterDateRange').hasClass("hide")) {
                    $('#filterDateRange').addClass("hide");
                    $("#filterDateRange .text-field").val("");
                    self.dateFilter.filterDateValue = [];
                }
                if ($('#selectedYearSection').hasClass("hide")) {
                    $('#selectedYearSection').removeClass("hide");
                    var currentYear = self.getCurrentYear();
                    self.selectedYear = { text : currentYear, value: currentYear}
                }
            }
        },
        loadProfitAndLossReport() {
            var self = this;
            self.loading = true;

            if (self.selectedFilter.value == "custom") {
                var fields = {
                    type:self.type,
                    year:self.selectedYear.value,
                    filterType:self.selectedFilter.value,
                    dateRange:self.dateFilter.filterDateValue,
                    action:self.action
                };
            }else{
                var fields = {
                    type:self.type,
                    year:self.selectedYear.value,
                    filterType:self.selectedFilter.value,
                    action:self.action
                };
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/accounting/reports/profit-loss",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                        if (self.action =='export'){

                            self.action = 'list';
                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                self.excel = data.content.web;
                                var save = document.createElement("a");
                                save.href = self.excel;
                                save.download = data.content.web;
                                save.target = "_blank";

                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);
                            }
                        }else{
                            self.headerArr = data.content.header;
                            self.profitLossSummary = data.content.summary;
                        }
                    }else{
                        self.$swal('',data.message,'info');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'profit-loss-report');
                }
            });
        },
        checkFilterValidation: function() {
            var self = this;
            var error = false;

            if (self.selectedFilter != null) {
                if (self.selectedFilter.value == "custom") {
                    if (self.dateFilter.filterDateValue == null || self.dateFilter.filterDateValue == "" || !self.dateFilter.filterDateValue) {
                        $("#filterDateRange .text-field").addClass('border-red');
                        error = true;
                    }else{
                        $("#filterDateRange .text-field").removeClass('border-red');    
                    }
                }else{
                    if (self.selectedYear == null || self.selectedYear.value == "") {
                        $("#selectedYear .dropdown-toggle").addClass('border-red');
                        error = true;
                    }else{
                        $("#selectedYear .dropdown-toggle").removeClass('border-red');
                    }
                }
            }

            if (self.selectedFilter == null || self.selectedFilter.value == "") {
                $("#selectedFilter .dropdown-toggle").addClass('border-red');
                error = true;
            }else{
                $("#selectedFilter .dropdown-toggle").removeClass('border-red');
            }

            return error;
        },
        onColumnFilter(flag) {
            var self = this;
            if ( flag == 'load' ) {
                var error = false;
                error = self.checkFilterValidation();
                if (!error) {
                    self.loadProfitAndLossReport();
                }
            }else{
                setTimeout(function(){                   
                    $("#filterDateRange .text-field").val("");
                    $("#filterDateRange .text-field").removeClass('border-red');
                    $("#selectedYear .dropdown-toggle").removeClass('border-red');
                    $("#selectedFilter .dropdown-toggle").removeClass('border-red');
                    $('#filterDateRange').addClass("hide");
                    if ($('#selectedYearSection').hasClass("hide")) {
                        $('#selectedYearSection').removeClass("hide");
                    }
                },200);

                self.dateFilter = {filterValue: null,filterDateValue: null};
                var currentYear = self.getCurrentYear();
                self.selectedYear = { text : currentYear, value: currentYear};
                self.selectedFilter = {text:"Quarterly",value:"quarter"};
                self.loadProfitAndLossReport();
            }
        },
        getCurrentYear() {
            var today = new Date();
            var yyyy = today.getFullYear();
            return yyyy.toString();
        },
        exportProfitLossSummary() {
            var self = this;
            this.action = "export";
            this.loadProfitAndLossReport();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/accounting/reports/ProfitAndLossReport.vue